import "./LinkButton.css";

function LinkButton({
  classes,
  text,
  icon,
  onClick,
  marginBottom = 120,
  backgroundMargin = 40,
}) {
  return (
    <>
      <div
        className={`${classes} LinkButton`}
        style={{ marginBottom: marginBottom }}
        onClick={() => onClick()}
      >
        <button className="LinkButtonBody">{text}</button>
        <div className="LinkButtonIcon">{icon}</div>
      </div>
      <div
        className="LinkButtonBackground"
        style={{ marginBottom: backgroundMargin }}
      ></div>
    </>
  );
}

export default LinkButton;
